// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-menubar .p-menubar {
  border: none;
  padding: 0;
  width: 100%;
}

.overflow-auto {
  background-color: #e6e6e6;
}

.p-menubar .p-menubar-root-list > .p-menuitem > .p-menuitem-content {
  color: #495057;
  transition: box-shadow 0.2s;
  border-radius: 0px;
}

.custom-menubar .p-menubar-root-list {
  width: 100%;
  max-height: 91vh;
  display: flex;
  flex-direction: row;
  list-style-type: none; /* Remove default bullet points */
  margin: 0; /* Remove default margin */
  padding: 0; /* Remove default padding */
  background-color: #002133;
  overflow-y: auto;
}
.custom-menubar .p-menubar-root-list::-webkit-scrollbar {
  width: 5px; /* Set the scrollbar width */
  background-color: white;
}
.custom-menubar .p-menubar-root-list::-webkit-scrollbar-thumb {
  background-color: gray; /* Scrollbar color */
  border-radius: 5px; /* Rounded scrollbar edges */
}
.custom-menubar .p-menubar-root-list li {
  text-align: left;
}
.bg-light {
  --bs-bg-opacity: 1 !important;
  background-color: #002133 !important;
}
.custom-menubar .p-menuitem-link {
  width: 100%;
  justify-content: flex-start;
  padding-left: 1rem;
  text-decoration: none;
}

.custom-menubar .p-menuitem-link .p-menuitem-icon {
  margin-right: 1rem;
}
.p-menubar .p-menuitem {
  position: relative;
  width: 100%;
}
.logo_dash {
  width: 175px;
  padding: 10px;
}

/* Default styles */

.image-fluid {
  width: 175px;
  padding: 10px;
}

/* Responsive styles */
@media (max-width: 960px) {
  .image-fluid {
    width: 100px; /* Adjust as needed */
    padding: 5px;
  }
  .custom-menubar {
    flex-direction: column;
    align-items: flex-start;
  }
  .logo_dash {
    width: 175px;
    padding: 10px;
  }
  .page-wrapper {
    margin-top: 120px;
    width: 500px;
  }
  .left-sidebar {
    width: 240px;
    height: 100vh;
    overflow: hidden;
    transition: all 0.2s ease;
    visibility: visible;
    opacity: 1;
    background-color: #002133;
  }
  .left-sidebar.hide-sidebar {
    width: 0;
    visibility: hidden;
    opacity: 0;
  }
}

.left-sidebar {
  width: 240px;
  height: 100vh;
  overflow: hidden;
  background-color: #002133;
  transition: all 0.2s ease;
  visibility: visible;
  opacity: 1;
}
.left-sidebar.hide-sidebar {
  width: 0;
  visibility: hidden;
  opacity: 0;
}
.top-header {
  top: 0;
  left: 240px;
  right: 0;
  z-index: 1000;
  background-color: lightgray;
}
.top-header.hide-sidebar {
  left: 0px;
}
.top-header .hide-sidebar-icon {
  cursor: pointer;
  padding: 5px;
  border-radius: 50%;
  border: 1px solid #002133;
}
.top-header .hide-sidebar-icon .pi {
  font-size: 18px;
}
.top-header .hide-sidebar-icon:hover {
  background-color: #002133;
  color: #fff;
  border-radius: 50%;
}
.second-header {
  top: 70px;
  background-color: #f8f9fa;
  right: 0px;
  /* top: 0; */
  left: 240px;
  right: 0;
  z-index: 1000;
  background-color: #fff;
}
.second-header.hide-sidebar {
  left: 0;
}
.br-c {
  border-radius: 10px !important;
}
.float-inline-end {
  float: inline-end !important;
}
.float-inherit {
  float: inherit !important;
}
.light-bg {
  background-color: #e0e0e0 !important;
}
.active-button {
  background-color: #002133 !important; /* Example active color */
  color: white !important; /* Text color for active button */
}
.inactive-button {
  color: gray !important; /* Text color for active button */
}
ul {
  padding-left: 0rem !important;
  margin-bottom: 0px !important;
}

.my-table {
  margin: 40px 0px;
}

.filter-header-row {
  --bs-gutter-x: 1.5rem !important;
  --bs-gutter-y: 0 !important;
  display: flex !important;
  flex-wrap: wrap !important;
  margin-right: calc(-0.5 * var(--bs-gutter-x)) !important;
  margin-left: calc(-0.5 * var(--bs-gutter-x)) !important;
  font-size: small;
  padding: 10px;
  border-bottom: 1px solid #dee2e6;
}
.managed-row {
  margin: 10px 0px;
  font-size: small;
}
.panel-footer {
  border-top: 1px solid #dee2e6;
}
.filter-label {
  color: gray;
}
.resetButton {
  background-color: #f5f5f5;
}
.column-scroll-container {
  display: flex;
  overflow-x: auto;
}
.column-cols {
  flex: 1 1 !important;
}
.pencil-icon {
  color: #06b6d4;
  cursor: pointer;
}
.charts-section .chart-block {
  border: 2px solid #002133;
  border-radius: 6px;
  height: 100%;
}
.chart-block .tooltip-content {
  border: 2px solid #002133;
  border-radius: 6px;
  color: #002133;
  font-weight: 600;
  font-size: 14px;
}
.chart-block .tooltip-content .sub-text {
  color: #9e9e9e;
  font-size: 12px;
}
.column-input.p-inputtext {
  border: none;
  border-bottom: 1px solid #ced4da;
  width: 80%;
}
.column-input.p-inputtext.search-input {
  width: 85%;
}
.filter-input-buttons .filter-input-button1 {
  border-radius: 50%;
  padding: 4px;
  background-color: #002133;
  border: 1px solid #002133;
}
.filter-input-buttons .filter-input-button2 {
  border-radius: 50%;
  padding: 4px;
  background-color: transparent;
  border: 1px solid #002133;
}
.filter-input-buttons .pi {
  font-size: 12px;
}
.filter-input-buttons .filter-input-button2 .pi-times {
  color: #002133;
}
.search-filter {
  position: relative;
}
.scroll-panel-custom.panel-height {
  max-height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
}
.household-chip {
  border: 3px solid #002133;
  background-color: #4cb050;
  font-size: 20px;
  font-weight: 600;
  padding: 2px 20px;
  display: inline-block;
  border-radius: 6px;
}

.card-style {
  border: 1px solid #d3d3d3;
  border-radius: 4px;
}

.text-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.filter-wrapper {
  position: relative;
  transition: all 0.1s ease;
}
.filter-wrapper.hide-filter {
  width: 0%;
}
.cursor-pointer {
  cursor: pointer;
}
.filter-wrapper .filter-hide-toggle {
  position: absolute;
  top: 12px;
  right: -12px;
  border: 1px solid #002133;
  display: flex;
  color: #002133;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  padding: 4px;
  cursor: pointer;
  background-color: #fff;
  z-index: 9;
}
.filter-wrapper.hide-filter .filter-hide-toggle {
  right: -22px;
}
.filter-wrapper .filter-hide-toggle:hover {
  background-color: #002133;
  color: #fff;
}
.sticky-sidebar::-webkit-scrollbar {
  width: 5px;
}
.sticky-sidebar::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.sticky-sidebar::-webkit-scrollbar-thumb {
  background: #d1d1d1;
  border-radius: 10px;
}
.sticky-sidebar::-webkit-scrollbar-thumb:hover {
  background: #d1d1d1;
}
.shadow-card {
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border: 0 !important;
  border-radius: 0px !important;
}
.shadow-card-2 {
  border: 0 !important;
  border-radius: 0px !important;
}
.createClientBtn, .delete {
  background-color: #333333;
  border: 0px;
  border-radius: 5px;
}
.createClientBtn.confirm-model {
  margin-left: 8px;
}
.shadow-card .p-divider.p-divider-horizontal {
  margin: 0rem 0 !important;
  padding: 0 1rem !important;
}
.title {
  color: #9e9e9e !important;
}
.pagination-text {
  color: #9e9e9e !important;
  font-size: 12px !important;
  font-weight: 600 !important;
}
.pagination-arrow {
  border: 2px solid #d1cdcd;
  border-radius: 17px;
  width: 30px;
  height: 30px;
  align-items: center;
  justify-content: center;
  display: flex;
  color: #3187fd;
  cursor: pointer;
}
.inputField {
  border-color: lightgray !important;
  background-color: #f5f5f5;
}
.inputField .p-inputnumber-input {
  border-color: lightgray !important;
  background-color: #f5f5f5;
  width: 140px;
}
.clientsTable,
.surveyTable {
  text-align: left;
}
.clientsTable thead th,
.surveyTable thead th {
  padding: 15px 10px 10px !important;
  color: #9e9e9e !important;
}
.clientsTable tbody td {
  padding: 15px !important;
  color: #666666 !important;
}
.surveyTable tbody td {
  padding: 9px !important;
  color: #666666 !important;
}
.clientsTableHead {
  border-bottom: 1px solid lightgray !important;
}
.divider-margin-top {
  margin-top: 10px !important;
}
.dark-text {
  color: #002133 !important;
}
.cancel {
  background-color: #eeeeee;
  border: 0px;
  border-radius: 5px;
  color: #333333;
}
.skeleton-box {
  background-color: #e0e0e0;
  border-radius: 4px;
  animation: pulse 1.5s infinite ease-in-out;
}
.limit-status {
  background: #f5f5f5;
  display: inline-block;
  border-radius: 25px;
  font-size: 10px;
}
.limit-status .pi-exclamation-triangle {
  padding-right: 2px;
  font-size: 10px;
}

@keyframes pulse {
  0% {
    opacity: 0.9;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 0.9;
  }
}

.p-dialog .p-dialog-header {
  border-bottom: 1px solid lightgray;
  background: #ffffff;
  color: #495057;
  padding: 1.5rem;
  border-top-right-radius: 3px;
  border-top-left-radius: 3px;
}

.error-content {
  text-align: left;
}
.col-custom {
  padding: 1.5rem !important;
  color: white !important;
  flex: 0 0 auto !important;
  width: 100% !important; /* Behaves like col-12 on mobile */
  text-align: justify !important;
}

@media (min-width: 768px) {
  .col-custom {
    width: 32% !important; /* 3 columns in a row on md+ screens */
  }
}

.tooltip-container {
  position: relative;
  display: inline-block;
  width: 100%;
}

.tooltip-trigger {
  cursor: pointer;
  display: inline-block;
  width: 100%;
}

.tooltip-text {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.3s ease-in-out;
  position: absolute;
  background-color: #bfbfbf;
  border-radius: 5px;
  padding: 5px;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  margin-bottom: 5px;
  width: 100%;
  color: #002133;
  font-size: 14px;
  box-shadow: 0px 0px 4px 0px #4b4949;
}

.tooltip-text .tooltip-heading {
  color: #002133;
  font-weight: 600;
}

.tooltip-container:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}

.tooltip-text::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: #bfbfbf transparent transparent transparent;
}
.calendar-input .p-inputtext {
  border: 0;
  border-bottom: 1px solid gray;
}
.bt-dropdown .dropdown-toggle {
  border-bottom: 1px solid #9e9e9e;
  color: #212529;
  font-weight: 600;
}
.bt-dropdown .dropdown-item {
  color: #9e9e9e;
  font-weight: 600;
  font-size: 15px;
}
.bt-dropdown .dropdown-menu li:not(:last-child) {
  border-bottom: 1px solid #e0e0e0;
}
.bt-dropdown .dropdown-item.active,
.dropdown-item:active {
  background-color: #ff9800;
  color: #002133;
}
.bt-dropdown .dropdown-item:active {
  background-color: #ff9800;
  color: #002133;
}
.panelOpener:hover {
  background: #e9ecef;
}
.text-color {
  color: #666666;
}
#survey_timeline_header p,
#participants_header p {
  font-weight: 400 !important;
}
.spinnerParent {
  position: "fixed";
  top: 0;
  left: 0;
  height: "100vh";
  width: "100vw";
  background-color: "rgba(255, 255, 255, 0.6)";
  z-index: 9999;
  display: "flex";
  justify-content: "center";
  align-items: "center";
}
/* Password Info Custom Tooltip */
.tooltip-container {
  position: relative;
  display: inline-block;
  cursor: pointer;
}
.tooltip-box {
  position: absolute;
  background-color: #002133;
  color: #fff;
  padding: 12px;
  border-radius: 4px;
  font-size: 14px;
  /* white-space: nowrap; */
  z-index: 1000;
  width: 100%;
}
.tooltip-box.top {
  bottom: 100%;
  left: 58%;
  transform: translateX(-50%);
  margin-bottom: 6px;
}
.custom-confirm-dialog .p-dialog-header {
  color: #002133;
  padding: 16px;
}
.custom-confirm-dialog .p-dialog-content {
  padding: 16px;
}
.custom-confirm-dialog .p-confirm-dialog-message {
  margin: 0;
}
.custom-confirm-dialog .p-dialog-footer {
  display: flex;
  justify-content: center;
  padding-top: 30px;
}
.custom-confirm-dialog .p-confirm-dialog-accept {
  margin-left: 16px;
}
/* Added top bottom css for future use */
.tooltip-box.bottom {
  top: 100%;
  left: 58%;
  transform: translateX(-50%);
  margin-top: 6px;
}
.tooltip-box.left {
  right: 100%;
  top: 50%;
  transform: translateY(-50%);
  margin-right: 6px;
}
.tooltip-box.right {
  left: 100%;
  top: 50%;
  transform: translateY(-50%);
  margin-left: 6px;
}
.tooltip-arrow {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
}
.tooltip-box.top .tooltip-arrow {
  bottom: -8px;
  left: 90%;
  transform: translateX(-50%);
  border-width: 8px 8px 0 8px;
  border-color: #002133 transparent transparent transparent;
}
.tooltip-box.bottom .tooltip-arrow {
  top: -8px;
  left: 90%;
  transform: translateX(-50%);
  border-width: 0px 8px 8px 8px;
  border-color: transparent transparent #002133 transparent;
}
/* End Password Info Custom Tooltip */
.addTaskQuesBtn {
  background-color: #333333;
  color: #fff;
  border-radius: 5px;
}
.addTaskQuesBtn .linkBtn {
  color: #fff;
}
.randomize-block {
  border: 1px solid #e5e5e5;
  font-size: 13px;
}
.randomize-block .randomize-ans-opt-text {
  color: #616161;
}
.inputField.error-input {
  border: 1px solid #dc3545 !important;
}
.form-select {
  border-color: lightgray !important;
  background-color: #f5f5f5 !important;
}
.form-select.error-input {
  border: 1px solid #dc3545 !important;
}
.randomization-block {
  border: 1px solid #e5e5e5;
}
.randomization-block .tq-btn {
  background-color: #ff9800;
  color: #fff;
}
/* xmot style */
.participant-table-wrapper {
  max-height: 400px;
  overflow-y: auto;
}
.participant-table-wrapper .clientsTable thead th {
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 2;
}
.participant-table-wrapper::-webkit-scrollbar {
  width: 6px;
}
.participant-table-wrapper::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}
.p-card.credit-card,
.p-card.details-card {
  border-radius: 18px !important;
}
.p-card.credit-card {
  border: 1px solid #eee !important;
}
.p-card.details-card {
  color: #fff !important;
  background: #002133 !important;
}
/* Circular Estimated Credits Indicator */
.circle-wrapper {
  position: relative;
}
.center-label {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}
.credit-value {
  font-size: 18px;
  font-weight: 600;
  color: #ff9800;
  display: block;
}
.credit-label {
  font-size: 14px;
  color: gray;
  display: block;
}
/* End of xmot style */
/* bootstrap radio input styling */
.form-check-input {
  width: 20px !important;
  height: 20px !important;
}
.form-check-input:checked {
  background-color: orange !important;
  border-color: orange !important;
}
.form-check-input:focus {
  border-color: orange !important;
  box-shadow: 0 0 0 0.25rem rgba(255, 165, 0, 0.25) !important; /* light orange glow */
}
.form-check-input:checked::before {
  background-color: orange !important; /* Inner circle color when checked */
}
/* End bootstrap radion input styling */
.error-border {
  border: 1px solid #dc3545 !important;
}

/* Active tab styling */
.p-tabview .p-tabview-nav li.p-highlight [data-pc-section="headeraction"],
.p-tabview .p-tabview-nav li.p-highlight [data-pc-section="headertitle"],
.p-tabview .p-tabview-nav li.p-highlight span.pi {
  color: #ff9800 !important;
}

/* Enabled but not active tabs */
.enabled-tab:not(.p-highlight) [data-pc-section="headeraction"],
.enabled-tab:not(.p-highlight) [data-pc-section="headertitle"],
.enabled-tab:not(.p-highlight) span.pi {
  color: #002133 !important;
}

/* Disabled tabs */
.disabled-tab [data-pc-section="headeraction"],
.disabled-tab [data-pc-section="headertitle"],
.disabled-tab span.pi {
  color: #ccc !important;
  opacity: 0.6;
}

/* Optional: Add underline for active tab */
.p-tabview .p-tabview-nav li.p-highlight {
  border-bottom-color: #ff9800 !important;
}

.logic-settings-icon {
  background-color: #f5f5f5;
  border: 0px;
  border-radius: 4px;
  color: #2196f3;
}
.p-overlaypanel-content {
  padding: 0px !important;
}
.skip-logic-modal .p-dialog-content {
  max-height: calc(90vh - 120px);
  min-height: 60vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}
.modal-dropdown .p-dropdown-item {
  white-space: normal !important;
  word-break: break-word;
}
.modal-dropdown .p-multiselect-item {
  white-space: normal !important;
  word-break: break-word;
  align-items: flex-start;
}
.modal-dropdown .p-dropdown-items-wrapper {
  max-height: 175px !important;
}
.modal-dropdown .p-multiselect-items-wrapper {
  max-height: 150px !important;
}
.stimuli-task-tooltip.p-tooltip .p-tooltip-text {
  box-shadow: none;
}
/* view-results-react styles */
.filter-by-theme .filter-button-text {
  color: #495057;
  border: 1px solid #ced4da;
  background-color: #f1f3f5;
}
.transcript-button-text {
  color: #002133;
  background-color: #f5f5f5;
  border-color: #f5f5f5;
  border-radius: 4px;
  line-height: 20px;
  font-weight: 600;
}
.transcript-button-text.active {
  color: #fff;
  background-color: #002133;
  border-color: #002133;
}
.transcript-search {
  border: 1px solid #eee;
  background-color: #eee;
}
.transcript-area::-webkit-scrollbar {
  width: 4px;
}
.transcript-tabs.p-tabview .p-tabview-panels {
  padding: 0 !important;
}
.tabview-vertical .p-tabview {
  display: flex;
  flex-direction: row;
}
.tabview-vertical .p-tabview-nav {
  flex-direction: column;
  min-width: 200px;
  border-bottom: none;
}
.tabview-vertical .p-tabview-panels {
  flex: 1 1;
}
.tabview-vertical .p-tabview .p-tabview-panels {
  padding: 16px !important;
}
.typescript-breadcrumb {
  border: 1px solid #dee2e6;
  padding: 8px;
  border-radius: 0;
}
.verticle-divider {
  border-right: 1px solid green;
}
.tabview-vertical .p-tabview-nav-link {
  padding: 16px 0px !important;
}
.tabview-vertical .p-tabview .p-tabview-nav li .p-tabview-nav-link {
  border-width: 0 2px 3px 0;
  border-right-color: #dee2e6;
  border-bottom-color: #dee2e6;
}
.tabview-vertical .p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {
  border-width: 0 4px 3px 0;
  border-right-color: #ff9800;
  border-bottom-color: #dee2e6;
}
.toggle-content-btn {
  position: absolute;
  top: 0px;
  right: 0px;
  background: #2196f3;
  color: #fff;
  width: 35px;
  height: 50px;
  border: none;
  font-size: 21px;
  font-weight: 600;
  border-radius: 25px 0 0 25px;
  text-align: right;
  box-shadow: -2px 0px 1px #333;
  line-height: 24px;
}
.save-bookmark {
  position: absolute;
  top: 40%;
  left: 10px;
}
.save-bookmark.save-bookmark-popup-open {
  top: 10%;
}
.save-bookmark-btn {
  background-color: rgb(81, 45, 168);
  color: #fff;
  padding: 6px;
  border-radius: 10px;
  font-size: 14px;
  border: none;
}
.save-bookmark .form-check-input:checked {
  background-color: #ff9800;
  border-color: #ff9800;
}
.gallery-thumb {
  transition: transform 0.2s;
}
.gallery-thumb:hover {
  transform: scale(1.05);
}
.img-fluid.active-thumb {
  border: 2px solid #f8971c !important;
}
.photo-gallery-icon .pi {
  color: #007bff;
  font-size: 20px;
}
/* Play Button */
.play-btn {
  position: absolute;
  bottom: 1%;
  left: 50%;
  border: none;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  color: white;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 0.25s;
}
.play-icon {
  margin-left: 3px; /* centers triangle visually */
}
.pause-icon {
  font-size: 14px;
}
/* Optional smooth scroll & scrollbar styling */
::-webkit-scrollbar {
  height: 8px;
}
::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 4px;
}
::-webkit-scrollbar-thumb:hover {
  background: #999;
}
.displayLabels {
  padding: 16px;
  margin: 0 0px 5px;
  background: #f5f5f5;
  border-radius: 4px;
}
.scroll-card.active {
  border: 2px solid #f8971c !important;
  opacity: 1 !important;
}
.scroll-card:hover {
  opacity: 0.8 !important;
}
.text-truncate {
  font-size: 14px;
  color: #fff;
  text-transform: capitalize;
  width: 100%;
  box-shadow: 0px -12px 18px #000 inset;
  padding: 3px 6px;
}
.filter-btn-wrapper {
  border: 1px solid #ccc;
}
.save-presentation-popup-wrapper {
  position: absolute;
  top: 38px;
  z-index: 1005;
}
.save-for-presentation {
  /* max-width: 500px; */
  width: 320px;
  background: rgba(0, 0, 0, 0.85);
  box-shadow: 0 0 0 1px #666;
  padding: 15px 12px;
}
.save-for-presentation h5 {
  border-bottom: 1px solid #666;
  padding-bottom: 12px;
}
.all-task-question-wrapper {
  border: 1px solid #ccc;
}
.all-task-question-wrapper .question-wrapper {
  background: #eee;
}
.all-task-question-wrapper .question-wrapper .instructions-content {
  min-height: 170px;
}
.all-task-question-wrapper .tqheadTitle {
  background: #fff;
  border-bottom: 1px solid #ccc;
}
.all-task-question-wrapper .tq-list {
  min-height: 200px;
  background: #eee;
  overflow: auto;
}
.filter-dropdown-panel {
  position: absolute;
  top: 100%;
  right: auto;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1000;
  background-color: #fff;
  min-width: 275px;
  margin-top: 2px;
  border: 1px solid #ddd;
  left: -35%;
  transform: translateX(-50%);
}
.previewClipOuter .timedingBtn {
  position: absolute;
  left: 50%;
  bottom: -15px;
  transform: translateX(-50%);
  background-color: #f5f5f5;
  border-color: #f5f5f5;
  border-radius: 20px;
  color: #002133;
}
.presentation-view {
  border: 1px solid #e5e5e5;
}
.session-dropdown .p-dropdown-item {
  white-space: unset;
  text-align: left;
}
.presentation-view .add-transition-btn {
  border-radius: 50%;
  background-color: #0288d1;
  width: 20px;
  height: 20px;
  color: #fff;
}
.color-groups .color-group {
  width: 25px;
  height: 25px;
}
.colorpicker .p-colorpicker-preview {
  width: 16px;
  height: 16px;
  border-radius: 0;
  border: 2px solid #333;
}
.colorpicker .color-picker-box {
  background-color: #eee;
}
.colorpicker .cusotm-color-input {
  border-radius: 0;
  border: 0;
  background: #f5f5f5;
}
.slider-item:hover {
  opacity: 1 !important;
  transition: opacity 0.3s ease-in-out;
}
.caption-preview {
  width: 92%;
  color: #000;
  position: absolute;
  left: 4%;
  top: 75%;
  z-index: 2;
  text-align: center;
  border: 1px dashed #000;
  background: rgba(255, 255, 255, 0.1);
  font-size: 24px;
  overflow: hidden;
}
.caption-preview .preview-text {
  text-align: center;
  border: 1px dashed #333;
}
.caption-preview-textarea {
  width: 92%;
  color: #000;
  position: absolute;
  left: 4%;
  top: 75%;
  z-index: 2;
  text-align: center;
  overflow: hidden;
}
.preview-textarea {
  background: rgba(255, 255, 255, 0.3);
  border: 2px dashed #333;
  color: #000;
}
.filter-panel {
  max-height: 280px;
  overflow: auto;
}
/* End of view-results-react styles */
`, "",{"version":3,"sources":["webpack://./src/assets/css/dashboard.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,UAAU;EACV,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,qBAAqB,EAAE,iCAAiC;EACxD,SAAS,EAAE,0BAA0B;EACrC,UAAU,EAAE,2BAA2B;EACvC,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,UAAU,EAAE,4BAA4B;EACxC,uBAAuB;AACzB;AACA;EACE,sBAAsB,EAAE,oBAAoB;EAC5C,kBAAkB,EAAE,4BAA4B;AAClD;AACA;EACE,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,oCAAoC;AACtC;AACA;EACE,WAAW;EACX,2BAA2B;EAC3B,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA,mBAAmB;;AAEnB;EACE,YAAY;EACZ,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE;IACE,YAAY,EAAE,qBAAqB;IACnC,YAAY;EACd;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,iBAAiB;IACjB,YAAY;EACd;EACA;IACE,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;IACnB,UAAU;IACV,yBAAyB;EAC3B;EACA;IACE,QAAQ;IACR,kBAAkB;IAClB,UAAU;EACZ;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,QAAQ;EACR,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,MAAM;EACN,WAAW;EACX,QAAQ;EACR,aAAa;EACb,2BAA2B;AAC7B;AACA;EACE,SAAS;AACX;AACA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,yBAAyB;EACzB,UAAU;EACV,YAAY;EACZ,WAAW;EACX,QAAQ;EACR,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,OAAO;AACT;AACA;EACE,8BAA8B;AAChC;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC,EAAE,yBAAyB;EAC/D,uBAAuB,EAAE,iCAAiC;AAC5D;AACA;EACE,sBAAsB,EAAE,iCAAiC;AAC3D;AACA;EACE,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,wBAAwB;EACxB,0BAA0B;EAC1B,wDAAwD;EACxD,uDAAuD;EACvD,gBAAgB;EAChB,aAAa;EACb,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,WAAW;AACb;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,oBAAkB;AACpB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,YAAY;EACZ,gCAAgC;EAChC,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;EACE,SAAS;AACX;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,wCAAwC;EACxC,oBAAoB;EACpB,6BAA6B;AAC/B;AACA;EACE,oBAAoB;EACpB,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;AAC7B;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;EACd,eAAe;AACjB;AACA;EACE,kCAAkC;EAClC,yBAAyB;AAC3B;AACA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,YAAY;AACd;AACA;;EAEE,gBAAgB;AAClB;AACA;;EAEE,kCAAkC;EAClC,yBAAyB;AAC3B;AACA;EACE,wBAAwB;EACxB,yBAAyB;AAC3B;AACA;EACE,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;AAC5C;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB,EAAE,kCAAkC;EAC1D,8BAA8B;AAChC;;AAEA;EACE;IACE,qBAAqB,EAAE,sCAAsC;EAC/D;AACF;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,oCAAoC;EACpC,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,eAAe;EACf,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,yDAAyD;AAC3D;AACA;EACE,SAAS;EACT,6BAA6B;AAC/B;AACA;EACE,gCAAgC;EAChC,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gCAAgC;AAClC;AACA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,2BAA2B;AAC7B;AACA;EACE,iBAAiB;EACjB,MAAM;EACN,OAAO;EACP,eAAe;EACf,cAAc;EACd,4CAA4C;EAC5C,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;AACA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,WAAW;AACb;AACA;EACE,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,SAAS;AACX;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA,wCAAwC;AACxC;EACE,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,iBAAiB;AACnB;AACA;EACE,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,2BAA2B;EAC3B,yDAAyD;AAC3D;AACA;EACE,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,6BAA6B;EAC7B,yDAAyD;AAC3D;AACA,qCAAqC;AACrC;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;EACzB,WAAW;AACb;AACA,eAAe;AACf;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,MAAM;EACN,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;AACA;;EAEE,8BAA8B;AAChC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,sBAAsB;EACtB,8BAA8B;AAChC;AACA,yCAAyC;AACzC;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;AACA;EACE,eAAe;EACf,WAAW;EACX,cAAc;AAChB;AACA,sBAAsB;AACtB,kCAAkC;AAClC;EACE,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,mCAAmC;EACnC,+BAA+B;AACjC;AACA;EACE,+BAA+B;EAC/B,4DAA4D,EAAE,sBAAsB;AACtF;AACA;EACE,mCAAmC,EAAE,oCAAoC;AAC3E;AACA,uCAAuC;AACvC;EACE,oCAAoC;AACtC;;AAEA,uBAAuB;AACvB;;;EAGE,yBAAyB;AAC3B;;AAEA,gCAAgC;AAChC;;;EAGE,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;;;EAGE,sBAAsB;EACtB,YAAY;AACd;;AAEA,2CAA2C;AAC3C;EACE,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;AACA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,uBAAuB;AACzB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,gBAAgB;AAClB;AACA,8BAA8B;AAC9B;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,sBAAsB;EACtB,sBAAsB;AACxB;AACA;EACE,UAAU;AACZ;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,SAAO;AACT;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,iBAAiB;EACjB,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;AACA;EACE,QAAQ;AACV;AACA;EACE,kCAAkC;EAClC,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB,EAAE,8BAA8B;AAClD;AACA;EACE,eAAe;AACjB;AACA,+CAA+C;AAC/C;EACE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,WAAW;EACX,0BAA0B;EAC1B,WAAW;EACX,qCAAqC;EACrC,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,YAAY;EACZ,+BAA+B;EAC/B,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,oBAAoB;AACtB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,UAAU;EACV,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,aAAa;EACb,2BAA2B;EAC3B,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,UAAU;EACV,kBAAkB;EAClB,uBAAuB;EACvB,oCAAoC;EACpC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA,qCAAqC","sourcesContent":[".custom-menubar .p-menubar {\n  border: none;\n  padding: 0;\n  width: 100%;\n}\n\n.overflow-auto {\n  background-color: #e6e6e6;\n}\n\n.p-menubar .p-menubar-root-list > .p-menuitem > .p-menuitem-content {\n  color: #495057;\n  transition: box-shadow 0.2s;\n  border-radius: 0px;\n}\n\n.custom-menubar .p-menubar-root-list {\n  width: 100%;\n  max-height: 91vh;\n  display: flex;\n  flex-direction: row;\n  list-style-type: none; /* Remove default bullet points */\n  margin: 0; /* Remove default margin */\n  padding: 0; /* Remove default padding */\n  background-color: #002133;\n  overflow-y: auto;\n}\n.custom-menubar .p-menubar-root-list::-webkit-scrollbar {\n  width: 5px; /* Set the scrollbar width */\n  background-color: white;\n}\n.custom-menubar .p-menubar-root-list::-webkit-scrollbar-thumb {\n  background-color: gray; /* Scrollbar color */\n  border-radius: 5px; /* Rounded scrollbar edges */\n}\n.custom-menubar .p-menubar-root-list li {\n  text-align: left;\n}\n.bg-light {\n  --bs-bg-opacity: 1 !important;\n  background-color: #002133 !important;\n}\n.custom-menubar .p-menuitem-link {\n  width: 100%;\n  justify-content: flex-start;\n  padding-left: 1rem;\n  text-decoration: none;\n}\n\n.custom-menubar .p-menuitem-link .p-menuitem-icon {\n  margin-right: 1rem;\n}\n.p-menubar .p-menuitem {\n  position: relative;\n  width: 100%;\n}\n.logo_dash {\n  width: 175px;\n  padding: 10px;\n}\n\n/* Default styles */\n\n.image-fluid {\n  width: 175px;\n  padding: 10px;\n}\n\n/* Responsive styles */\n@media (max-width: 960px) {\n  .image-fluid {\n    width: 100px; /* Adjust as needed */\n    padding: 5px;\n  }\n  .custom-menubar {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  .logo_dash {\n    width: 175px;\n    padding: 10px;\n  }\n  .page-wrapper {\n    margin-top: 120px;\n    width: 500px;\n  }\n  .left-sidebar {\n    width: 240px;\n    height: 100vh;\n    overflow: hidden;\n    transition: all 0.2s ease;\n    visibility: visible;\n    opacity: 1;\n    background-color: #002133;\n  }\n  .left-sidebar.hide-sidebar {\n    width: 0;\n    visibility: hidden;\n    opacity: 0;\n  }\n}\n\n.left-sidebar {\n  width: 240px;\n  height: 100vh;\n  overflow: hidden;\n  background-color: #002133;\n  transition: all 0.2s ease;\n  visibility: visible;\n  opacity: 1;\n}\n.left-sidebar.hide-sidebar {\n  width: 0;\n  visibility: hidden;\n  opacity: 0;\n}\n.top-header {\n  top: 0;\n  left: 240px;\n  right: 0;\n  z-index: 1000;\n  background-color: lightgray;\n}\n.top-header.hide-sidebar {\n  left: 0px;\n}\n.top-header .hide-sidebar-icon {\n  cursor: pointer;\n  padding: 5px;\n  border-radius: 50%;\n  border: 1px solid #002133;\n}\n.top-header .hide-sidebar-icon .pi {\n  font-size: 18px;\n}\n.top-header .hide-sidebar-icon:hover {\n  background-color: #002133;\n  color: #fff;\n  border-radius: 50%;\n}\n.second-header {\n  top: 70px;\n  background-color: #f8f9fa;\n  right: 0px;\n  /* top: 0; */\n  left: 240px;\n  right: 0;\n  z-index: 1000;\n  background-color: #fff;\n}\n.second-header.hide-sidebar {\n  left: 0;\n}\n.br-c {\n  border-radius: 10px !important;\n}\n.float-inline-end {\n  float: inline-end !important;\n}\n.float-inherit {\n  float: inherit !important;\n}\n.light-bg {\n  background-color: #e0e0e0 !important;\n}\n.active-button {\n  background-color: #002133 !important; /* Example active color */\n  color: white !important; /* Text color for active button */\n}\n.inactive-button {\n  color: gray !important; /* Text color for active button */\n}\nul {\n  padding-left: 0rem !important;\n  margin-bottom: 0px !important;\n}\n\n.my-table {\n  margin: 40px 0px;\n}\n\n.filter-header-row {\n  --bs-gutter-x: 1.5rem !important;\n  --bs-gutter-y: 0 !important;\n  display: flex !important;\n  flex-wrap: wrap !important;\n  margin-right: calc(-0.5 * var(--bs-gutter-x)) !important;\n  margin-left: calc(-0.5 * var(--bs-gutter-x)) !important;\n  font-size: small;\n  padding: 10px;\n  border-bottom: 1px solid #dee2e6;\n}\n.managed-row {\n  margin: 10px 0px;\n  font-size: small;\n}\n.panel-footer {\n  border-top: 1px solid #dee2e6;\n}\n.filter-label {\n  color: gray;\n}\n.resetButton {\n  background-color: #f5f5f5;\n}\n.column-scroll-container {\n  display: flex;\n  overflow-x: auto;\n}\n.column-cols {\n  flex: 1 !important;\n}\n.pencil-icon {\n  color: #06b6d4;\n  cursor: pointer;\n}\n.charts-section .chart-block {\n  border: 2px solid #002133;\n  border-radius: 6px;\n  height: 100%;\n}\n.chart-block .tooltip-content {\n  border: 2px solid #002133;\n  border-radius: 6px;\n  color: #002133;\n  font-weight: 600;\n  font-size: 14px;\n}\n.chart-block .tooltip-content .sub-text {\n  color: #9e9e9e;\n  font-size: 12px;\n}\n.column-input.p-inputtext {\n  border: none;\n  border-bottom: 1px solid #ced4da;\n  width: 80%;\n}\n.column-input.p-inputtext.search-input {\n  width: 85%;\n}\n.filter-input-buttons .filter-input-button1 {\n  border-radius: 50%;\n  padding: 4px;\n  background-color: #002133;\n  border: 1px solid #002133;\n}\n.filter-input-buttons .filter-input-button2 {\n  border-radius: 50%;\n  padding: 4px;\n  background-color: transparent;\n  border: 1px solid #002133;\n}\n.filter-input-buttons .pi {\n  font-size: 12px;\n}\n.filter-input-buttons .filter-input-button2 .pi-times {\n  color: #002133;\n}\n.search-filter {\n  position: relative;\n}\n.scroll-panel-custom.panel-height {\n  max-height: 200px;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n.household-chip {\n  border: 3px solid #002133;\n  background-color: #4cb050;\n  font-size: 20px;\n  font-weight: 600;\n  padding: 2px 20px;\n  display: inline-block;\n  border-radius: 6px;\n}\n\n.card-style {\n  border: 1px solid #d3d3d3;\n  border-radius: 4px;\n}\n\n.text-overflow {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.filter-wrapper {\n  position: relative;\n  transition: all 0.1s ease;\n}\n.filter-wrapper.hide-filter {\n  width: 0%;\n}\n.cursor-pointer {\n  cursor: pointer;\n}\n.filter-wrapper .filter-hide-toggle {\n  position: absolute;\n  top: 12px;\n  right: -12px;\n  border: 1px solid #002133;\n  display: flex;\n  color: #002133;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n  padding: 4px;\n  cursor: pointer;\n  background-color: #fff;\n  z-index: 9;\n}\n.filter-wrapper.hide-filter .filter-hide-toggle {\n  right: -22px;\n}\n.filter-wrapper .filter-hide-toggle:hover {\n  background-color: #002133;\n  color: #fff;\n}\n.sticky-sidebar::-webkit-scrollbar {\n  width: 5px;\n}\n.sticky-sidebar::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n.sticky-sidebar::-webkit-scrollbar-thumb {\n  background: #d1d1d1;\n  border-radius: 10px;\n}\n.sticky-sidebar::-webkit-scrollbar-thumb:hover {\n  background: #d1d1d1;\n}\n.shadow-card {\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  border: 0 !important;\n  border-radius: 0px !important;\n}\n.shadow-card-2 {\n  border: 0 !important;\n  border-radius: 0px !important;\n}\n.createClientBtn, .delete {\n  background-color: #333333;\n  border: 0px;\n  border-radius: 5px;\n}\n.createClientBtn.confirm-model {\n  margin-left: 8px;\n}\n.shadow-card .p-divider.p-divider-horizontal {\n  margin: 0rem 0 !important;\n  padding: 0 1rem !important;\n}\n.title {\n  color: #9e9e9e !important;\n}\n.pagination-text {\n  color: #9e9e9e !important;\n  font-size: 12px !important;\n  font-weight: 600 !important;\n}\n.pagination-arrow {\n  border: 2px solid #d1cdcd;\n  border-radius: 17px;\n  width: 30px;\n  height: 30px;\n  align-items: center;\n  justify-content: center;\n  display: flex;\n  color: #3187fd;\n  cursor: pointer;\n}\n.inputField {\n  border-color: lightgray !important;\n  background-color: #f5f5f5;\n}\n.inputField .p-inputnumber-input {\n  border-color: lightgray !important;\n  background-color: #f5f5f5;\n  width: 140px;\n}\n.clientsTable,\n.surveyTable {\n  text-align: left;\n}\n.clientsTable thead th,\n.surveyTable thead th {\n  padding: 15px 10px 10px !important;\n  color: #9e9e9e !important;\n}\n.clientsTable tbody td {\n  padding: 15px !important;\n  color: #666666 !important;\n}\n.surveyTable tbody td {\n  padding: 9px !important;\n  color: #666666 !important;\n}\n.clientsTableHead {\n  border-bottom: 1px solid lightgray !important;\n}\n.divider-margin-top {\n  margin-top: 10px !important;\n}\n.dark-text {\n  color: #002133 !important;\n}\n.cancel {\n  background-color: #eeeeee;\n  border: 0px;\n  border-radius: 5px;\n  color: #333333;\n}\n.skeleton-box {\n  background-color: #e0e0e0;\n  border-radius: 4px;\n  animation: pulse 1.5s infinite ease-in-out;\n}\n.limit-status {\n  background: #f5f5f5;\n  display: inline-block;\n  border-radius: 25px;\n  font-size: 10px;\n}\n.limit-status .pi-exclamation-triangle {\n  padding-right: 2px;\n  font-size: 10px;\n}\n\n@keyframes pulse {\n  0% {\n    opacity: 0.9;\n  }\n  50% {\n    opacity: 0.5;\n  }\n  100% {\n    opacity: 0.9;\n  }\n}\n\n.p-dialog .p-dialog-header {\n  border-bottom: 1px solid lightgray;\n  background: #ffffff;\n  color: #495057;\n  padding: 1.5rem;\n  border-top-right-radius: 3px;\n  border-top-left-radius: 3px;\n}\n\n.error-content {\n  text-align: left;\n}\n.col-custom {\n  padding: 1.5rem !important;\n  color: white !important;\n  flex: 0 0 auto !important;\n  width: 100% !important; /* Behaves like col-12 on mobile */\n  text-align: justify !important;\n}\n\n@media (min-width: 768px) {\n  .col-custom {\n    width: 32% !important; /* 3 columns in a row on md+ screens */\n  }\n}\n\n.tooltip-container {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n}\n\n.tooltip-trigger {\n  cursor: pointer;\n  display: inline-block;\n  width: 100%;\n}\n\n.tooltip-text {\n  visibility: visible;\n  opacity: 1;\n  transition: opacity 0.3s ease-in-out;\n  position: absolute;\n  background-color: #bfbfbf;\n  border-radius: 5px;\n  padding: 5px;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 10;\n  margin-bottom: 5px;\n  width: 100%;\n  color: #002133;\n  font-size: 14px;\n  box-shadow: 0px 0px 4px 0px #4b4949;\n}\n\n.tooltip-text .tooltip-heading {\n  color: #002133;\n  font-weight: 600;\n}\n\n.tooltip-container:hover .tooltip-text {\n  visibility: visible;\n  opacity: 1;\n}\n\n.tooltip-text::after {\n  content: \"\";\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  margin-left: -5px;\n  border-width: 5px;\n  border-style: solid;\n  border-color: #bfbfbf transparent transparent transparent;\n}\n.calendar-input .p-inputtext {\n  border: 0;\n  border-bottom: 1px solid gray;\n}\n.bt-dropdown .dropdown-toggle {\n  border-bottom: 1px solid #9e9e9e;\n  color: #212529;\n  font-weight: 600;\n}\n.bt-dropdown .dropdown-item {\n  color: #9e9e9e;\n  font-weight: 600;\n  font-size: 15px;\n}\n.bt-dropdown .dropdown-menu li:not(:last-child) {\n  border-bottom: 1px solid #e0e0e0;\n}\n.bt-dropdown .dropdown-item.active,\n.dropdown-item:active {\n  background-color: #ff9800;\n  color: #002133;\n}\n.bt-dropdown .dropdown-item:active {\n  background-color: #ff9800;\n  color: #002133;\n}\n.panelOpener:hover {\n  background: #e9ecef;\n}\n.text-color {\n  color: #666666;\n}\n#survey_timeline_header p,\n#participants_header p {\n  font-weight: 400 !important;\n}\n.spinnerParent {\n  position: \"fixed\";\n  top: 0;\n  left: 0;\n  height: \"100vh\";\n  width: \"100vw\";\n  background-color: \"rgba(255, 255, 255, 0.6)\";\n  z-index: 9999;\n  display: \"flex\";\n  justify-content: \"center\";\n  align-items: \"center\";\n}\n/* Password Info Custom Tooltip */\n.tooltip-container {\n  position: relative;\n  display: inline-block;\n  cursor: pointer;\n}\n.tooltip-box {\n  position: absolute;\n  background-color: #002133;\n  color: #fff;\n  padding: 12px;\n  border-radius: 4px;\n  font-size: 14px;\n  /* white-space: nowrap; */\n  z-index: 1000;\n  width: 100%;\n}\n.tooltip-box.top {\n  bottom: 100%;\n  left: 58%;\n  transform: translateX(-50%);\n  margin-bottom: 6px;\n}\n.custom-confirm-dialog .p-dialog-header {\n  color: #002133;\n  padding: 16px;\n}\n.custom-confirm-dialog .p-dialog-content {\n  padding: 16px;\n}\n.custom-confirm-dialog .p-confirm-dialog-message {\n  margin: 0;\n}\n.custom-confirm-dialog .p-dialog-footer {\n  display: flex;\n  justify-content: center;\n  padding-top: 30px;\n}\n.custom-confirm-dialog .p-confirm-dialog-accept {\n  margin-left: 16px;\n}\n/* Added top bottom css for future use */\n.tooltip-box.bottom {\n  top: 100%;\n  left: 58%;\n  transform: translateX(-50%);\n  margin-top: 6px;\n}\n.tooltip-box.left {\n  right: 100%;\n  top: 50%;\n  transform: translateY(-50%);\n  margin-right: 6px;\n}\n.tooltip-box.right {\n  left: 100%;\n  top: 50%;\n  transform: translateY(-50%);\n  margin-left: 6px;\n}\n.tooltip-arrow {\n  content: \"\";\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-style: solid;\n}\n.tooltip-box.top .tooltip-arrow {\n  bottom: -8px;\n  left: 90%;\n  transform: translateX(-50%);\n  border-width: 8px 8px 0 8px;\n  border-color: #002133 transparent transparent transparent;\n}\n.tooltip-box.bottom .tooltip-arrow {\n  top: -8px;\n  left: 90%;\n  transform: translateX(-50%);\n  border-width: 0px 8px 8px 8px;\n  border-color: transparent transparent #002133 transparent;\n}\n/* End Password Info Custom Tooltip */\n.addTaskQuesBtn {\n  background-color: #333333;\n  color: #fff;\n  border-radius: 5px;\n}\n.addTaskQuesBtn .linkBtn {\n  color: #fff;\n}\n.randomize-block {\n  border: 1px solid #e5e5e5;\n  font-size: 13px;\n}\n.randomize-block .randomize-ans-opt-text {\n  color: #616161;\n}\n.inputField.error-input {\n  border: 1px solid #dc3545 !important;\n}\n.form-select {\n  border-color: lightgray !important;\n  background-color: #f5f5f5 !important;\n}\n.form-select.error-input {\n  border: 1px solid #dc3545 !important;\n}\n.randomization-block {\n  border: 1px solid #e5e5e5;\n}\n.randomization-block .tq-btn {\n  background-color: #ff9800;\n  color: #fff;\n}\n/* xmot style */\n.participant-table-wrapper {\n  max-height: 400px;\n  overflow-y: auto;\n}\n.participant-table-wrapper .clientsTable thead th {\n  position: sticky;\n  top: 0;\n  background: #fff;\n  z-index: 2;\n}\n.participant-table-wrapper::-webkit-scrollbar {\n  width: 6px;\n}\n.participant-table-wrapper::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 4px;\n}\n.p-card.credit-card,\n.p-card.details-card {\n  border-radius: 18px !important;\n}\n.p-card.credit-card {\n  border: 1px solid #eee !important;\n}\n.p-card.details-card {\n  color: #fff !important;\n  background: #002133 !important;\n}\n/* Circular Estimated Credits Indicator */\n.circle-wrapper {\n  position: relative;\n}\n.center-label {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-align: center;\n}\n.credit-value {\n  font-size: 18px;\n  font-weight: 600;\n  color: #ff9800;\n  display: block;\n}\n.credit-label {\n  font-size: 14px;\n  color: gray;\n  display: block;\n}\n/* End of xmot style */\n/* bootstrap radio input styling */\n.form-check-input {\n  width: 20px !important;\n  height: 20px !important;\n}\n.form-check-input:checked {\n  background-color: orange !important;\n  border-color: orange !important;\n}\n.form-check-input:focus {\n  border-color: orange !important;\n  box-shadow: 0 0 0 0.25rem rgba(255, 165, 0, 0.25) !important; /* light orange glow */\n}\n.form-check-input:checked::before {\n  background-color: orange !important; /* Inner circle color when checked */\n}\n/* End bootstrap radion input styling */\n.error-border {\n  border: 1px solid #dc3545 !important;\n}\n\n/* Active tab styling */\n.p-tabview .p-tabview-nav li.p-highlight [data-pc-section=\"headeraction\"],\n.p-tabview .p-tabview-nav li.p-highlight [data-pc-section=\"headertitle\"],\n.p-tabview .p-tabview-nav li.p-highlight span.pi {\n  color: #ff9800 !important;\n}\n\n/* Enabled but not active tabs */\n.enabled-tab:not(.p-highlight) [data-pc-section=\"headeraction\"],\n.enabled-tab:not(.p-highlight) [data-pc-section=\"headertitle\"],\n.enabled-tab:not(.p-highlight) span.pi {\n  color: #002133 !important;\n}\n\n/* Disabled tabs */\n.disabled-tab [data-pc-section=\"headeraction\"],\n.disabled-tab [data-pc-section=\"headertitle\"],\n.disabled-tab span.pi {\n  color: #ccc !important;\n  opacity: 0.6;\n}\n\n/* Optional: Add underline for active tab */\n.p-tabview .p-tabview-nav li.p-highlight {\n  border-bottom-color: #ff9800 !important;\n}\n\n.logic-settings-icon {\n  background-color: #f5f5f5;\n  border: 0px;\n  border-radius: 4px;\n  color: #2196f3;\n}\n.p-overlaypanel-content {\n  padding: 0px !important;\n}\n.skip-logic-modal .p-dialog-content {\n  max-height: calc(90vh - 120px);\n  min-height: 60vh;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n}\n.modal-dropdown .p-dropdown-item {\n  white-space: normal !important;\n  word-break: break-word;\n}\n.modal-dropdown .p-multiselect-item {\n  white-space: normal !important;\n  word-break: break-word;\n  align-items: flex-start;\n}\n.modal-dropdown .p-dropdown-items-wrapper {\n  max-height: 175px !important;\n}\n.modal-dropdown .p-multiselect-items-wrapper {\n  max-height: 150px !important;\n}\n.stimuli-task-tooltip.p-tooltip .p-tooltip-text {\n  box-shadow: none;\n}\n/* view-results-react styles */\n.filter-by-theme .filter-button-text {\n  color: #495057;\n  border: 1px solid #ced4da;\n  background-color: #f1f3f5;\n}\n.transcript-button-text {\n  color: #002133;\n  background-color: #f5f5f5;\n  border-color: #f5f5f5;\n  border-radius: 4px;\n  line-height: 20px;\n  font-weight: 600;\n}\n.transcript-button-text.active {\n  color: #fff;\n  background-color: #002133;\n  border-color: #002133;\n}\n.transcript-search {\n  border: 1px solid #eee;\n  background-color: #eee;\n}\n.transcript-area::-webkit-scrollbar {\n  width: 4px;\n}\n.transcript-tabs.p-tabview .p-tabview-panels {\n  padding: 0 !important;\n}\n.tabview-vertical .p-tabview {\n  display: flex;\n  flex-direction: row;\n}\n.tabview-vertical .p-tabview-nav {\n  flex-direction: column;\n  min-width: 200px;\n  border-bottom: none;\n}\n.tabview-vertical .p-tabview-panels {\n  flex: 1;\n}\n.tabview-vertical .p-tabview .p-tabview-panels {\n  padding: 16px !important;\n}\n.typescript-breadcrumb {\n  border: 1px solid #dee2e6;\n  padding: 8px;\n  border-radius: 0;\n}\n.verticle-divider {\n  border-right: 1px solid green;\n}\n.tabview-vertical .p-tabview-nav-link {\n  padding: 16px 0px !important;\n}\n.tabview-vertical .p-tabview .p-tabview-nav li .p-tabview-nav-link {\n  border-width: 0 2px 3px 0;\n  border-right-color: #dee2e6;\n  border-bottom-color: #dee2e6;\n}\n.tabview-vertical .p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {\n  border-width: 0 4px 3px 0;\n  border-right-color: #ff9800;\n  border-bottom-color: #dee2e6;\n}\n.toggle-content-btn {\n  position: absolute;\n  top: 0px;\n  right: 0px;\n  background: #2196f3;\n  color: #fff;\n  width: 35px;\n  height: 50px;\n  border: none;\n  font-size: 21px;\n  font-weight: 600;\n  border-radius: 25px 0 0 25px;\n  text-align: right;\n  box-shadow: -2px 0px 1px #333;\n  line-height: 24px;\n}\n.save-bookmark {\n  position: absolute;\n  top: 40%;\n  left: 10px;\n}\n.save-bookmark.save-bookmark-popup-open {\n  top: 10%;\n}\n.save-bookmark-btn {\n  background-color: rgb(81, 45, 168);\n  color: #fff;\n  padding: 6px;\n  border-radius: 10px;\n  font-size: 14px;\n  border: none;\n}\n.save-bookmark .form-check-input:checked {\n  background-color: #ff9800;\n  border-color: #ff9800;\n}\n.gallery-thumb {\n  transition: transform 0.2s;\n}\n.gallery-thumb:hover {\n  transform: scale(1.05);\n}\n.img-fluid.active-thumb {\n  border: 2px solid #f8971c !important;\n}\n.photo-gallery-icon .pi {\n  color: #007bff;\n  font-size: 20px;\n}\n/* Play Button */\n.play-btn {\n  position: absolute;\n  bottom: 1%;\n  left: 50%;\n  border: none;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  color: white;\n  font-size: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: 0.25s;\n}\n.play-icon {\n  margin-left: 3px; /* centers triangle visually */\n}\n.pause-icon {\n  font-size: 14px;\n}\n/* Optional smooth scroll & scrollbar styling */\n::-webkit-scrollbar {\n  height: 8px;\n}\n::-webkit-scrollbar-thumb {\n  background: #ccc;\n  border-radius: 4px;\n}\n::-webkit-scrollbar-thumb:hover {\n  background: #999;\n}\n.displayLabels {\n  padding: 16px;\n  margin: 0 0px 5px;\n  background: #f5f5f5;\n  border-radius: 4px;\n}\n.scroll-card.active {\n  border: 2px solid #f8971c !important;\n  opacity: 1 !important;\n}\n.scroll-card:hover {\n  opacity: 0.8 !important;\n}\n.text-truncate {\n  font-size: 14px;\n  color: #fff;\n  text-transform: capitalize;\n  width: 100%;\n  box-shadow: 0px -12px 18px #000 inset;\n  padding: 3px 6px;\n}\n.filter-btn-wrapper {\n  border: 1px solid #ccc;\n}\n.save-presentation-popup-wrapper {\n  position: absolute;\n  top: 38px;\n  z-index: 1005;\n}\n.save-for-presentation {\n  /* max-width: 500px; */\n  width: 320px;\n  background: rgba(0, 0, 0, 0.85);\n  box-shadow: 0 0 0 1px #666;\n  padding: 15px 12px;\n}\n.save-for-presentation h5 {\n  border-bottom: 1px solid #666;\n  padding-bottom: 12px;\n}\n.all-task-question-wrapper {\n  border: 1px solid #ccc;\n}\n.all-task-question-wrapper .question-wrapper {\n  background: #eee;\n}\n.all-task-question-wrapper .question-wrapper .instructions-content {\n  min-height: 170px;\n}\n.all-task-question-wrapper .tqheadTitle {\n  background: #fff;\n  border-bottom: 1px solid #ccc;\n}\n.all-task-question-wrapper .tq-list {\n  min-height: 200px;\n  background: #eee;\n  overflow: auto;\n}\n.filter-dropdown-panel {\n  position: absolute;\n  top: 100%;\n  right: auto;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 1000;\n  background-color: #fff;\n  min-width: 275px;\n  margin-top: 2px;\n  border: 1px solid #ddd;\n  left: -35%;\n  transform: translateX(-50%);\n}\n.previewClipOuter .timedingBtn {\n  position: absolute;\n  left: 50%;\n  bottom: -15px;\n  transform: translateX(-50%);\n  background-color: #f5f5f5;\n  border-color: #f5f5f5;\n  border-radius: 20px;\n  color: #002133;\n}\n.presentation-view {\n  border: 1px solid #e5e5e5;\n}\n.session-dropdown .p-dropdown-item {\n  white-space: unset;\n  text-align: left;\n}\n.presentation-view .add-transition-btn {\n  border-radius: 50%;\n  background-color: #0288d1;\n  width: 20px;\n  height: 20px;\n  color: #fff;\n}\n.color-groups .color-group {\n  width: 25px;\n  height: 25px;\n}\n.colorpicker .p-colorpicker-preview {\n  width: 16px;\n  height: 16px;\n  border-radius: 0;\n  border: 2px solid #333;\n}\n.colorpicker .color-picker-box {\n  background-color: #eee;\n}\n.colorpicker .cusotm-color-input {\n  border-radius: 0;\n  border: 0;\n  background: #f5f5f5;\n}\n.slider-item:hover {\n  opacity: 1 !important;\n  transition: opacity 0.3s ease-in-out;\n}\n.caption-preview {\n  width: 92%;\n  color: #000;\n  position: absolute;\n  left: 4%;\n  top: 75%;\n  z-index: 2;\n  text-align: center;\n  border: 1px dashed #000;\n  background: rgba(255, 255, 255, 0.1);\n  font-size: 24px;\n  overflow: hidden;\n}\n.caption-preview .preview-text {\n  text-align: center;\n  border: 1px dashed #333;\n}\n.caption-preview-textarea {\n  width: 92%;\n  color: #000;\n  position: absolute;\n  left: 4%;\n  top: 75%;\n  z-index: 2;\n  text-align: center;\n  overflow: hidden;\n}\n.preview-textarea {\n  background: rgba(255, 255, 255, 0.3);\n  border: 2px dashed #333;\n  color: #000;\n}\n.filter-panel {\n  max-height: 280px;\n  overflow: auto;\n}\n/* End of view-results-react styles */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
